(() => {
  const STATUS_ICONS = {
    instock: "https://cdn.shopify.com/s/files/1/0528/6831/7368/files/auf_lager.svg?v=1774522602",
    backorder: "https://cdn.shopify.com/s/files/1/0528/6831/7368/files/bestellware.svg?v=1774522602",
    soldout: "https://cdn.shopify.com/s/files/1/0528/6831/7368/files/nicht_verfuegbar.svg?v=1774522602"
  };

  function getVariantIdFromForm(root) {
    const form =
      root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput && idInput.value ? idInput.value : null;
  }

  function setState(root, state, message) {
    const labelEl = root.querySelector(".delivery-info__label");
    const iconEl = root.querySelector(".delivery-info__icon");
    if (!labelEl) return;

    if (state === "is-instock" && iconEl) {
      iconEl.src = STATUS_ICONS.instock;
    }

    if (state === "is-backorder" && iconEl) {
      iconEl.src = STATUS_ICONS.backorder;
    }

    if (state === "is-soldout" && iconEl) {
      iconEl.src = STATUS_ICONS.soldout;
    }

    labelEl.textContent = message;
  }

  function render(root, variants, leadtime, variantId) {
    const v = variants[String(variantId)];
    if (!v) return;

    const tracked = v.inventory_management === "shopify";
    const qty = Number(v.qty) || 0;
    const available = !!v.available;

if (root.dataset.preorder === "true") {
  if (available) {
    const preorderDate = (root.dataset.preorderDate || "").trim();
    const message = preorderDate
      ? `Voraussichtlich lieferbar ab ${preorderDate}`
      : "Vorbestellbar – Liefertermin auf Anfrage";

    setState(root, "is-backorder", message);
  } else {
    setState(root, "is-soldout", "Derzeit leider nicht verfügbar");
  }
  return;
}

    if (!tracked) {
      if (available) {
        setState(
          root,
          "is-backorder",
          `Bestellware - Voraussichtlich lieferbar innerhalb von ${leadtime}`
        );
      } else {
        setState(root, "is-soldout", "Derzeit leider nicht verfügbar");
      }
      return;
    }

    if (qty > 0) {
      if (qty < 5) {
        setState(
          root,
          "is-instock",
          `Nur noch ${qty} Stück verfügbar - sofort lieferbar`
        );
      } else {
        setState(root, "is-instock", "Sofort lieferbar");
      }
      return;
    }

    if (available) {
      setState(
        root,
        "is-backorder",
        `Bestellware - Voraussichtlich lieferbar innerhalb von ${leadtime}`
      );
    } else {
      setState(root, "is-soldout", "Derzeit leider nicht verfügbar");
    }
  }

  function initOne(root) {
    if (root.dataset.deliveryInfoInitialized === "true") return;
    root.dataset.deliveryInfoInitialized = "true";

    const variants = JSON.parse(root.dataset.variants || "{}");
    const leadtime = (root.dataset.leadtime || "").trim() || "auf Anfrage";
    const initialVariant = root.dataset.initialVariant || null;

    const current = getVariantIdFromForm(root) || initialVariant;
    if (current) render(root, variants, leadtime, current);

    const form =
      root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    form.addEventListener("change", () => {
      const id = getVariantIdFromForm(root);
      if (id) render(root, variants, leadtime, id);
    });

    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      let last = idInput.value;
      setInterval(() => {
        if (idInput.value !== last) {
          last = idInput.value;
          render(root, variants, leadtime, last);
        }
      }, 300);
    }
  }

  function initAll() {
    document.querySelectorAll(".delivery-info").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();